// RVI.js
import * as d3 from 'd3';
import theme from '../../theme';

export const drawRVI = (svg, data, xScale, yScale, values) => {
    if (!values?.rvi || !values?.signal) return;

    const rviPoints = values.rvi.map((value, i) => ({
        x: new Date(data[i]?.start_date),
        y: value
    })).filter(d => !isNaN(d.y) && d.y !== null);

    const signalPoints = values.signal.map((value, i) => ({
        x: new Date(data[i]?.start_date),
        y: value
    })).filter(d => !isNaN(d.y) && d.y !== null);

    const lineGenerator = d3.line()
        .x(d => xScale(d.x))
        .y(d => yScale(d.y))
        .curve(d3.curveMonotoneX);

    // RVI line
    svg.append('path')
        .datum(rviPoints)
        .attr('fill', 'none')
        .attr('stroke', theme.indicators.rvi.line)
        .attr('stroke-width', 1.5)
        .attr('d', lineGenerator);

    // Signal line
    svg.append('path')
        .datum(signalPoints)
        .attr('fill', 'none')
        .attr('stroke', theme.indicators.rvi.signal)
        .attr('stroke-width', 1.5)
        .attr('stroke-dasharray', '3,3')
        .attr('d', lineGenerator);
};